export default __webpack_public_path__ + "static/media/b3.6bf08fe8.jpg";